module.exports = __webpack_public_path__ + "img/11_17.31f3ffe8.png";